export default require("./node_modules/react/jsx-dev-runtime.js");